import { render, staticRenderFns } from "./RegistrationDetailed.vue?vue&type=template&id=22e51ee8&scoped=true&"
import script from "./RegistrationDetailed.vue?vue&type=script&lang=js&"
export * from "./RegistrationDetailed.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationDetailed.vue?vue&type=style&index=0&id=22e51ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e51ee8",
  null
  
)

export default component.exports